export default __webpack_public_path__ + "static/media/person3.04d435bc.png";